<script>
    import Main from './layout/Main.svelte';
    import Filemanager from "../com/Filemanager/Filemanager.svelte";
    import { t } from "../i18n";

    let comFilemanager;
    let quotationFolders = [];

    $: comFilemanager && comFilemanager.on('data', function(data) {
        let isQuot = n => n && n.match(/^Q\d+$/);
        quotationFolders = (data||[]).filter(o=>o.dir && isQuot(o.name));
    });

    // folder menu titles follow the active language
    $: if(comFilemanager) {
        let rename = n => n && $t('files.group', {n: n.replace(/^Q(\d+)$/, '$1')});
        comFilemanager.set_menu(quotationFolders.map(f => ({id: f.name, title: rename(f.name), extra: 0})));
    }

    $: comFilemanager && comFilemanager.on('changeFolder', function(data) {
        let path = '/' + data;
        comFilemanager.set_path(path);
    });

</script>


<Main title={$t('page.invoices')}>

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">

            <div class="container-fluid">
                <div class="row">
                    <div class="col">


                        <Filemanager bind:this={comFilemanager} path="/"></Filemanager>

                        
                    </div>
                </div>
            </div>

        </div>
    </div>

</Main>
